import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

/** Single browser client; safe to import everywhere. */
let client = null;

export function getSupabaseClient() {
  if (!url || !anonKey) {
    return null;
  }
  if (!client) {
    client = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    });
  }
  return client;
}

export function hasSupabaseConfig() {
  return Boolean(url && anonKey);
}

/** Base URL for Edge Functions. */
export function getSupabaseFunctionsUrl(functionName) {
  if (!url) return null;
  return `${url.replace(/\/$/, '')}/functions/v1/${functionName}`;
}
